import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { AnalyticsConfig } from 'uitk-react-utils';
import { UitkCardTextSegment } from 'uitk-react-cards';

import { LocalizedToggle } from 'components/common/localized-toggle';

interface PropertyDetailsSegmentProps {
  analytics?: AnalyticsConfig;
  dataStid: string;
  errorBoundaryLabel: string;
  isToggleHidden?: boolean;
  rootClassName: string;
  title: string;
  navigationRef?: React.RefObject<any>;
}

interface PropertyDetailsSegmentState {
  isVisible: boolean;
}

export class PropertyDetailsSegment extends React.Component<PropertyDetailsSegmentProps, PropertyDetailsSegmentState> {
  constructor(props) {
    super(props);
    this.state = { isVisible: false };
    this.toggleDisplay = this.toggleDisplay.bind(this);
  }

  private toggleDisplay() {
    this.setState(prevState => ({
      isVisible: !prevState.isVisible
    }));
  }

  public render() {
    const { analytics, children, dataStid, errorBoundaryLabel, isToggleHidden, rootClassName, title, navigationRef } = this.props;
    const segmentClassName = `${rootClassName} policies__card all-cell-1-1`;
    const titleClassName = `${rootClassName}__title policies__header--primary uitk-type-heading-600 uitk-type-bold all-b-padding-two`;
    const toggleClassName = `${rootClassName}__toggle policies__toggle`;

    return (
      <ErrorBoundary label={errorBoundaryLabel}>
        <UitkCardTextSegment className={segmentClassName} data-stid={dataStid}>
          <div className="all-y-padding-three" ref={navigationRef}>
            {title && <h3 className={titleClassName}>{title}</h3>}
            {isToggleHidden ? (
              <React.Fragment>{children}</React.Fragment>
            ) : (
              <LocalizedToggle
                className={toggleClassName}
                analytics={analytics}
                isVisible={this.state.isVisible}
                handleClick={this.toggleDisplay}
                collapseHeight={160}
              >
                {children}
              </LocalizedToggle>
            )}
          </div>
        </UitkCardTextSegment>
      </ErrorBoundary>
    );
  }
}
